import { CSSProperties, forwardRef } from 'react';

import clsx from 'clsx';

import IAspectRatioProps from './AspectRatio.def';
import styles from './aspectRatio.module.css';

/**
 * Use for any case where a `height` (or `min-height`) determined by a fixed aspect ratio is needed
 *
 * Set widescreen ratio:
 *
 * ```tsx
 * <AspectRatio ratio={16/9}>
 *  { content }
 * </AspectRatio>
 * ```
 *
 * Set ratio, but allow long content to expand height:
 *
 * ```tsx
 * <AspectRatio ratio={16/9} asMinHeight>
 *  { content potentially taller than aspect ratio }
 * </AspectRatio>
 * ```
 */
export const AspectRatio = forwardRef<HTMLDivElement, IAspectRatioProps>(({ ratio, children, asMinHeight, style, className, fwdCss, css, ...restProps }, ref) => (
	<div
		style={{ '--ratio': ratio, ...css, ...style } as CSSProperties}
		className={clsx(styles.root, !asMinHeight && styles.asAbsolute, className)}
		{...restProps}
		ref={ref}
	>
		{!!children && (
			<div
				className={styles.content}
				style={fwdCss}
			>
				{children}
			</div>
		)}
	</div>
));
